export default __webpack_public_path__ + "fbf06b7b5a8d40e038158179508c3d74.webp";